import { render } from "./BookedCruiseCard.vue?vue&type=template&id=35c4a7f6&scoped=true"
import script from "./BookedCruiseCard.vue?vue&type=script&lang=js"
export * from "./BookedCruiseCard.vue?vue&type=script&lang=js"

import "./BookedCruiseCard.vue?vue&type=style&index=0&id=35c4a7f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c4a7f6"]])

export default __exports__